import React, { useEffect } from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Header from "components/header/Header.js";
import { GetCookie, ParseJwt } from "api/jwt.js";
import useGetMember from "./hooks/useGetMember";
import WelcomeBanner from "./components/welcomeBanner/WelcomeBanner";
import ProfilePadding from "./components/ProfilePadding/ProfilePadding";
import SpondGroups from "./components/SpondGroups/SpondGroups";
import MemberDetailsContainer from "./components/MembersDetailsContainer/MembersDetailsContainer";
import NewMemberPromptToPay from "./components/NewMemberPromptToPay/NewMemberPromptToPay";
import { InformationContainer } from "./components/welcomeBanner/WelcomeBanner.styled";
import {
  InformationContainerInner,
  SvgDotPattern1,
} from "./components/SpondGroups/SpondGroups.styles";
import CoachesInfo from "components/account/privilegedViews/CoachesInfo";
import AdminSection from "./components/AdminSection/AdminSection";

const HeaderLight = tw(Header)`tw-text-gray-100`;

export default () => {
  const idToken = GetCookie("idToken");
  if (idToken === "") {
    window.location.href = "/login";
  }
  const firstName = ParseJwt(idToken).given_name;
  const membershipNumber = ParseJwt(idToken)["cognito:username"];

  const { getMember, memberDetails, isAdult, isMember, isLoading } =
    useGetMember();

  useEffect(() => {
    getMember();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnimationRevealPage>
      <>
        <HeaderLight />
        <ProfilePadding firstName={firstName}>
          {isLoading && (
            <WelcomeBanner
              memberDetails={memberDetails}
              isLoading={isLoading}
            />
          )}
          {!isLoading && (
            <>
              {isMember && (
                <>
                  <WelcomeBanner
                    memberDetails={memberDetails}
                    isLoading={isLoading}
                  />
                  <SpondGroups
                    memberDetails={memberDetails}
                    isAdult={isAdult}
                  />
                  <MemberDetailsContainer
                    membershipNumber={membershipNumber}
                    memberDetails={memberDetails}
                    isAdult={isAdult}
                    refreshMember={getMember}
                  />
                </>
              )}
              {(memberDetails.isCoach || memberDetails.isActivator) && (
                <>
                  <InformationContainer>
                    <SvgDotPattern1 />
                    <InformationContainerInner></InformationContainerInner>
                    <CoachesInfo
                      memberDetails={memberDetails}
                      refreshMember={getMember}
                      isEditable={true}
                    ></CoachesInfo>
                  </InformationContainer>
                </>
              )}
              {(memberDetails.isCoach ||
                memberDetails.isActivator ||
                memberDetails.isAdmin) && (
                <AdminSection memberDetails={memberDetails} />
              )}
            </>
          )}
          {!isLoading && !isMember && (
            <>
              <NewMemberPromptToPay
                isAdult={isAdult}
                membershipNumber={membershipNumber}
              />
            </>
          )}
        </ProfilePadding>
      </>
      <Footer />
    </AnimationRevealPage>
  );
};
